export default __webpack_public_path__ + "static/media/photo5.99621f68.jpg";